module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-text-828387f6.svg";